import {
  useWSModalCustom,
  WSModal,
  WSModalCustomProps,
  WSTable,
  WSTableCell,
  WSTableColumn,
  WSTableItem,
  WSText
} from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";

import { PaystubWorkLog } from "../types";

const columns: WSTableColumn<PaystubWorkLog>[] = [
  {
    config: { header: { text: "Worklog" }, gridTemplateSizeMax: "1fr" },
    renderFunction: ({ data }) => <WSTableCell text={data.label} />
  },
  {
    config: { header: { text: "Amount" }, justify: "end" },
    renderFunction: ({ data }) => (
      <WSTableCell text={formatMoney(data.amount, Currency.USD)} />
    )
  }
];

type Props = {
  workLogs: PaystubWorkLog[];
  onWorkLogOpen?: (id: string) => void;
} & WSModalCustomProps<void>;

const ModalReviewExcludedWorkLogs: React.FC<Props> = props => {
  const tableData: WSTableItem<PaystubWorkLog>[] = props.workLogs.map(
    workLog => ({
      id: workLog.id,
      data: workLog
    })
  );

  return (
    <WSModal
      actions={{
        alignment: "fill",
        buttons: [
          { label: "Done", kind: "Tertiary", onClick: () => props.onClose() }
        ]
      }}
      size="M"
      title="Not included work logs"
      onClose={() => props.onClose()}
    >
      <WSText.ParagraphSm color="gray500" mb="M">
        After a payroll run is finalized and paid, any work logs not included
        can only be paid in a separate off-cycle run.
      </WSText.ParagraphSm>
      <WSTable<PaystubWorkLog>
        columns={columns}
        tableData={tableData}
        onRowClick={item => props.onWorkLogOpen?.(item.id)}
      />
    </WSModal>
  );
};

export const useModalReviewExcludedWorkLogs = () =>
  useWSModalCustom(ModalReviewExcludedWorkLogs);
